import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Style/Profile.css';
import useUsersData from './AllUsers';
import TopNavbar from '../home/TopNavbar';

// Helper: add 5h 30m and format nicely
const toIST = (dateString) => {
    if (!dateString) return 'Loading...';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

// Helper: get background color from name
const getAvatarColor = (name) => {
    if (!name) return '#3b82f6';
    const colors = [
        '#e53e3e', '#dd6b20', '#d69e2e', '#38a169',
        '#319795', '#3182ce', '#5a67d8', '#805ad5',
        '#d53f8c', '#00bcd4', '#ed8936', '#48bb78'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

const Profile = () => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userPhone, setUserPhone] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [userClass, setUserClass] = useState('');
    const [registerDate, setRegisterDate] = useState('');
    const [lastLogin, setLastLogin] = useState('');
    const [userId, setUserId] = useState('');

    // State declarations for payment variables
    const [isPayment, setIsPayment] = useState(false);
    const [itemName, setItemName] = useState('');
    const [itemprice, setItemPrice] = useState('');
    const [itemDetails, setItemDetails] = useState('');
    const [itemValid, setItemValid] = useState('');
    const [itemYear, setItemYear] = useState('');

    const { users, loading } = useUsersData();

    useEffect(() => {
        // User details
        const phoneFromStorage = localStorage.getItem('userPhone');
        const emailFromStorage = localStorage.getItem('userEmail');
        const nameFromStorage = localStorage.getItem('userName');
        const classFromStorage = localStorage.getItem('userClass');
        const userIdFromStorage = localStorage.getItem('userId');
        const regDateFromStorage = localStorage.getItem('registerDate');
        const lastLoginFromStorage = localStorage.getItem('lastLogin');

        // User payment details stored into React state
        setIsPayment(localStorage.getItem('userPayment'));
        setItemName(localStorage.getItem('itemName'));
        setItemPrice(localStorage.getItem('itemPrice'));
        setItemDetails(localStorage.getItem('itemAbout'));
        setItemValid(localStorage.getItem('itemValid'));
        setItemYear(localStorage.getItem('itemYear'));

        if (!phoneFromStorage) {
            navigate('/signup');
            return;
        }

        setIsLoggedIn(true);
        setUserPhone(phoneFromStorage);
        setUserEmail(emailFromStorage);
        setUserName(nameFromStorage);
        setUserClass(classFromStorage);
        setRegisterDate(regDateFromStorage);
        setLastLogin(lastLoginFromStorage);
        setUserId(userIdFromStorage || '');
    }, [navigate]);

    // Optional user matching
    const targetUser = users.find(user => user.phone === userPhone);
    const name = targetUser?.name || "Loading";
    const firstLetter = userName.charAt(0).toUpperCase();
    const avatarColor = getAvatarColor(name);

    return (
        <div className="profile-page-container">
            <div className="profile-content-wrapper">
                <TopNavbar name="Profile" />
                <div className="profile-card">

                    {/* Header with gradient + overlapping avatar */}
                    <div className="profile-header">
                        <div
                            className="profile-avatar"
                            style={{
                                backgroundColor: avatarColor,
                                color: '#fff',
                                fontWeight: '700'
                            }}
                        >
                            {firstLetter}
                        </div>
                        <h2>{userName}</h2>
                    </div>

                    <div className="profile-details">
                        <div className="detail-item">
                            <span className="detail-label">Name:</span>
                            <span className="detail-value">{userName || 'Loading...'}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Class</span>
                            <span className="detail-value">{userClass || 'Loading...'}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Phone</span>
                            <span className="detail-value">{userPhone}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Email ID</span>
                            <span className="detail-value">{userEmail || 'Loading...'}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Register Date</span>
                            <span className="detail-value">{toIST(registerDate)}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Last Login</span>
                            <span className="detail-value">{toIST(lastLogin)}</span>
                        </div>
                    </div>

                    {isPayment ? (
                        <div className="profile-details">
                            <p style={{ textAlign: "center", padding: "10px" }}>Purchase details</p>
                            <hr></hr>
                            <div className="detail-item">
                                <span className="detail-label">Item Name:</span>
                                <span className="detail-value">{itemName || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Validity:</span>
                                <span className="detail-value">{itemValid || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Price:</span>
                                <span className="detail-value">{itemprice || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Details:</span>
                                <span className="detail-value">{itemDetails || 'Loading...'}</span>
                            </div>
                        </div>
                    ) : null}

                    <div className="profile-actions-container">
                        <Link to="/update-profile" className="btn-profile btn-update">
                            Update Profile
                        </Link>
                        <Link to="/logout" className="btn-profile btn-logout">
                            Logout
                        </Link>
                    </div>

                    <div className="profile-actions-container">
                        <Link to="/account-delete" className="btn-profile btn-warning">
                            Delete Account
                        </Link>
                    </div>
                    <br /><br /><br /><br />
                </div>
            </div>
        </div>
    );
};

export default Profile;